/**
 * React Query keys for customers
 */

export const queryKey = {
  getCustomerList: 'CUSTOMERS_GET_LIST',
  getCustomerDetail: 'CUSTOMERS_GET_DETAIL',
  getCustomerStats: 'CUSTOMERS_GET_STATS',
  getCustomerCountByStatus: 'CUSTOMERS_GET_COUNT_BY_STATUS',
  getAllCustomerCountsByStatus: 'CUSTOMERS_GET_ALL_COUNTS_BY_STATUS',
  getCreditHistory: 'CUSTOMERS_GET_CREDIT_HISTORY',
};
